import { useState } from "react";

import { Typography, Button, Stack, Snackbar, Alert } from "@common-ui/ui";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { deleteService, getOrgServiceTypes } from "../../services/services";
export const RemoveServiceDialog = ({
  open,
  handleClose,
  currentMaintenancePlanId,
  currentOrgId,
  setMaintenancePlans,
  getMaintenancePlans,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [openToast, setOpenToast] = useState(false);
  const [warning, setWarning] = useState(false);
  const handleRemoveMaintenancePlan = async () => {
    setIsLoading(true);
    try {
      await deleteService(currentOrgId, currentMaintenancePlanId);
      let services = await getOrgServiceTypes();
      setMaintenancePlans(services);
      setOpenToast(true);
      handleClose();
      setIsLoading(false);
    } catch (error) {
      // alert(error.message);
      setWarning(true);
      setOpenToast(true);
      handleClose();
      setIsLoading(false);
    }
  };

  const handleCancelClick = () => {
    setIsLoading(false);
    handleClose();
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenToast(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleCancelClick}
        aria-labelledby="contact-remove"
        aria-describedby="contact-remove-dialog"
        fullWidth
      >
        <DialogContent>
          <Stack alignItems="left">
            <Typography variant="h4">
              Are you sure you want to remove this service?
            </Typography>
          </Stack>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="flex-end"
            spacing={{ xs: 1, md: 2 }}
            sx={{ px: 3, pt: 3 }}
          >
            <div>
              <Button
                color="primary"
                size="small"
                variant="text"
                onClick={handleCancelClick}
              >
                No, Cancel
              </Button>
            </div>
            <div>
              <Button
                color="primary"
                disabled={isLoading}
                size="small"
                variant="contained"
                onClick={handleRemoveMaintenancePlan}
              >
                Yes, Remove
              </Button>
            </div>
          </Stack>
        </DialogContent>
      </Dialog>
      {warning ? (
        <Snackbar
          open={openToast}
          autoHideDuration={6000}
          onClose={handleCloseToast}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseToast}
            severity="warning"
            sx={{ width: "100%" }}
            variant="filled"
          >
            Sorry! You need to remove all groups under this service to
            continuing.
          </Alert>
        </Snackbar>
      ) : (
        <Snackbar
          open={openToast}
          autoHideDuration={6000}
          onClose={handleCloseToast}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={handleCloseToast}
            severity="success"
            sx={{ width: "100%" }}
            variant="filled"
          >
            service has been removed successfully.
          </Alert>
        </Snackbar>
      )}
    </div>
  );
};
